import { randomBytes } from "crypto";

export default function generateRandomToken() {
  return randomBytes(124).toString("base64");
}
